import { atom } from 'nanostores';

export type UserData = {
  email: string;
  maxPrompts: string;
  promptsUsed: string;
  lastUpdated: string;
  isSubscribed: boolean;
};

export const userStore = atom<UserData>({
  email: 'user_email@gmail.com',
  isSubscribed: false,
  maxPrompts: '20',
  promptsUsed: '0',
  lastUpdated: new Date().toISOString(),
});

export function updateUserData(data: {
  email: string;
  maxPrompts: number;
  promptsUsed: number;
  isSubscribed: boolean;
}) {
  console.log('[UserStatus] Updating user data:', data);
  userStore.set({
    email: data.email,
    isSubscribed: data.isSubscribed,
    maxPrompts: data.maxPrompts.toString(),
    promptsUsed: data.promptsUsed.toString(),
    lastUpdated: new Date().toISOString(),
  });
}
